/* tslint:disable */
/* eslint-disable */
/**
 * Trust Investigator APP
 * The Law Society Trust Investigation Api with Swagger, Swashbuckle, and API Versioning.
 *
 * OpenAPI spec version: 2.0
 * Contact: hitesh.patel@lawsociety.com.au
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { BreachReportIEnumerableResponse } from '../models';
import { BreachReportRequest } from '../models';
import { BreachRequest } from '../models';
import { BreachWithoutQuestionIEnumerableResponse } from '../models';
/**
 * BreachApi - axios parameter creator
 * @export
 */
export const BreachApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Returns Breaches
         * @param {BreachRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2BreachGetBreachesPost: async (body?: BreachRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Breach/GetBreaches`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns Breaches
         * @param {BreachReportRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2BreachGetReportGenerationBreachesPost: async (body?: BreachReportRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Breach/GetReportGenerationBreaches`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BreachApi - functional programming interface
 * @export
 */
export const BreachApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Returns Breaches
         * @param {BreachRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2BreachGetBreachesPost(body?: BreachRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BreachWithoutQuestionIEnumerableResponse>> {
            const localVarAxiosArgs = await BreachApiAxiosParamCreator(configuration).apiV2BreachGetBreachesPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns Breaches
         * @param {BreachReportRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2BreachGetReportGenerationBreachesPost(body?: BreachReportRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BreachReportIEnumerableResponse>> {
            const localVarAxiosArgs = await BreachApiAxiosParamCreator(configuration).apiV2BreachGetReportGenerationBreachesPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * BreachApi - factory interface
 * @export
 */
export const BreachApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Returns Breaches
         * @param {BreachRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2BreachGetBreachesPost(body?: BreachRequest, options?: any): AxiosPromise<BreachWithoutQuestionIEnumerableResponse> {
            return BreachApiFp(configuration).apiV2BreachGetBreachesPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns Breaches
         * @param {BreachReportRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2BreachGetReportGenerationBreachesPost(body?: BreachReportRequest, options?: any): AxiosPromise<BreachReportIEnumerableResponse> {
            return BreachApiFp(configuration).apiV2BreachGetReportGenerationBreachesPost(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BreachApi - object-oriented interface
 * @export
 * @class BreachApi
 * @extends {BaseAPI}
 */
export class BreachApi extends BaseAPI {
    /**
     * 
     * @summary Returns Breaches
     * @param {BreachRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BreachApi
     */
    public apiV2BreachGetBreachesPost(body?: BreachRequest, options?: any) {
        return BreachApiFp(this.configuration).apiV2BreachGetBreachesPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Returns Breaches
     * @param {BreachReportRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BreachApi
     */
    public apiV2BreachGetReportGenerationBreachesPost(body?: BreachReportRequest, options?: any) {
        return BreachApiFp(this.configuration).apiV2BreachGetReportGenerationBreachesPost(body, options).then((request) => request(this.axios, this.basePath));
    }
}
